import React from 'react';
import './style.css';
import Item from './Item';
import { Truck } from './truck'
import { Mouse } from './mouse'
import { Heart } from './heart'
import { Gallery } from './gallery';

const HowToPurchaseItemData = [
    {
        icon: <Gallery />,
        title: 'בחרו את התמונות',
        description: 'תרכזו את התמונות שתרצו לקבל, המערכת כבר תתריע לכם  על תמונה שלא מתאימה להדפסה', 
        number: 1
    },
    {
        icon: <Mouse />,
        title: 'סמנו סוג מסגרת',
        description: 'בחרו את סוג המסגרת על פי טעמכם בעזרת הדמייה של התמונות שבחרתם',
        number: 2
    },
    {
        icon: <Truck />,
        title: 'אשרו כתובת למשלוח',
        description: 'הכניסו פרטי משלוח באיזור הקופה, המערכת תדאג למשלוח עד פתח הבית',
        number: 3
    },
    {
        icon: <Heart />,
        title: 'עצבו את הקיר שלכם',
        description: 'התמונות יגיעו אליכם בתוך קופסה מעוצבת עם מדבקות, תוכלו לסדר את התמונות על הקיר בעזרת המדבקות וליצור קיר תמונות מרהיב',
        number: 4
    }
]

const HowToPurchase = () => {
  return (
    <div className="htp-modal">
      {HowToPurchaseItemData.map((item, index) => (
        <Item
          key={item.number}
          description={item.description}
          icon={item.icon}
          number={item.number}
          title={item.title}
          isLast={index === HowToPurchaseItemData.length - 1}
        />
      ))}
    </div>
  );
};

export default HowToPurchase
